// Timesheet-sjablonen per departement. Bron: doc 5
// (Timesheets-zzp-opdrachten-film-en-AV-productie-2.0-dec-2025-FIN.xlsx)
// via seed-migratie 00005.
// AUTO-GEGENEREERD door scripts/genereer_timesheets.py. Niet handmatig wijzigen.

export const timesheets = {
  "animatie": {
    "label": "Animatie",
    "hoofdwerk": [
      "Briefen van animatoren bij aanvang van shots",
      "Feedback en approvals geven op animatie",
      "Overleg met regisseur met betrekking tot animatie/acteerwerk",
      "Voortgangsoverleg met productie",
      "Maken van live action referentievideo's"
    ],
    "voorbereiding": [
      "Bekijken van animatic en eerder gemaakt relevant materiaal",
      "Maken van 'animation bible' vóór de start van de animatoren",
      "Ontwikkelen van stijltests, eventueel met animation supervisor(s)",
      "Rigs/poppen testen"
    ],
    "afronding": [
      "Laatste controle van shots na lightning en rendering voor technische aanpassingen",
      "Controle shots in definitieve edit"
    ],
    "pr_promotie": []
  },
  "art-costume-hair-makeup": {
    "label": "Art / Kostuum / H&MU",
    "hoofdwerk": [
      "Ontwerpwerkzaamheden, niet op set (bijvoorbeeld kostuumontwerp)",
      "Op set werkzaamheden (zoals haar en make-up verzorgen voor cast op draaidagen, inclusief afschminken)",
      "Praktische voorbereiding draaidag (zoals spullen checken, wisseltas maken, pruiken opkappen etc.)",
      "Overleg (zoals binnen eigen departement en met andere departementen)",
      "Aansturen assistenten etc."
    ],
    "voorbereiding": [
      "Script lezen, callsheets lezen, script breakdown verwerken",
      "Inkopen verzorgen",
      "Research, en ontwerp/ontwikkeling personages in samenspraak met acteurs en regisseur",
      "Samenstellen planningen",
      "Doorpas acteurs",
      "Overleg en afstemming figuratiesupervisor en assistenten",
      "Overige overleg voorafgaand aan hoofdwerkzaamheden, stijlbesprekingen, breakdownvergaderingen",
      "Aansturen van en overleg / afstemming met VFX",
      "Inpakken materialen"
    ],
    "afronding": [
      "Verzamelen, opruimen, sorteren materiaal (zoals make-up, props)",
      "Wassen en stomen kostuums",
      "Retourneren materialen, artikelen"
    ],
    "pr_promotie": []
  },
  "camera-licht-grip": {
    "label": "Camera / Licht / Grip",
    "hoofdwerk": [
      "Draaien",
      "Opbouwen, testen en opruimen van apparatuur",
      "Overleg (met regisseur, DoP, 1st AD, productie, etc.)",
      "Aansturen van cam crew, licht, grip, camera assistenten/DIT/operator"
    ],
    "voorbereiding": [
      "Script lezen",
      "Overleg (met regisseur en production designer, VFX supervisor, etc.) en breakdown vergadering(en), voorafgaand aan de draaidagen",
      "Overleg met rental in verband met apparatuur, laden van apparatuur",
      "Overleg met eigen crew (licht, grip, assistentie)",
      "Research en samenstellen stijlpakket",
      "Voorbereidende handelingen (decouperen, plattegrond maken, kleding en make-up testen, LUT bouwen, etc.)",
      "Locatiebezoek/recces"
    ],
    "afronding": [
      "Grading bijwonen en aansturen, rushes en montageversies bekijken",
      "Retourneren van apparatuur"
    ],
    "pr_promotie": []
  },
  "casting-acteren": {
    "label": "Casting",
    "hoofdwerk": [
      "Draaidagen",
      "Blauwtjes, pinky's, tekst doornemen na een draaidag voor de volgende draaidag",
      "Tussentijdse repetities (buiten draaidagen om)",
      "Reis- holddagen"
    ],
    "voorbereiding": [
      "Casting",
      "Kennismaking/meeting team (exclusief werksessie/casting)",
      "Tegenspel castings",
      "Doorpassen kleding/pruiken, visagie voorbereiden",
      "Zelfstandig tekst leren, script analyseren, rol uitdiepen, research",
      "Repetities",
      "Kapper en persoonlijke verzorging voor rol",
      "Camera/HMU test",
      "Lezing",
      "Briefings, overleggen, aanwezigheid bijeenkomsten"
    ],
    "afronding": [
      "ADR"
    ],
    "pr_promotie": [
      "Voorbereiding en aanwezigheid première",
      "Postershoot",
      "Persdag, interviews"
    ]
  },
  "productie-geluid": {
    "label": "Geluid productie",
    "hoofdwerk": [
      "Sound mixen: van achter de production sound mixer cart",
      "Boom operaten",
      "Utility: opbouw en aanpassen van de filmset tbv verbetering van de klank",
      "Zenderen van de acteurs: afhankelijk van project door de psm, 1st sound assistent of utility",
      "Wild opnames met personen (los van beeld geluid opnemen van personen), locaties of voertuigen/apparaten",
      "Documentaire mixen & boomen, one man band",
      "Sound reports maken: tbv beeld en soundedit",
      "Sound file back up: voor persoonlijke back-up (DIT/datahandler zorgt meestal) voor de masterfiles",
      "Draaidag opstart en afronding: batterijen van en op de lader, apparatuur schoonmaak en ordenen",
      "Transport: inladen, uitladen, rijden van en naar de filmlocatie"
    ],
    "voorbereiding": [
      "Script lezen en analyseren + voorbereiding van stijlmeeting(s) (incl. aangepaste scriptversies)",
      "Stijlmeeting(s)",
      "Geluidsmeeting met regie, sounddesigner, componist, productie. Volledige scriptbehandeling 'geluidsdecoupage'",
      "Script breakdown (geluids-breakdown; schema maken om technische uitdagingen te ondervangen), breakdown op draaiplanning en per draailocatie",
      "Locatiebezoeken en recces, inclusief terugkoppeling en analyse van recces",
      "Overleg en plannen van aanpak i.s.m. andere vakgebieden (bijv. art department, opnameleiding) rond technische uitdagingen",
      "Gear build en gear test, workflow test (met de gehele technische crew)",
      "Technisch voorbereiden van een draaidag (mobiele set-up, studio set-up ivm diverse locaties en situaties)",
      "Technisch voorbereiden van geluidsfragmenten (muziek, off-screen cue lines, playback, earwig aansturing, telefoon aftap)",
      "Mbt buitenland: carnet",
      "Mbt buitenland: apparatuur transportklaar maken",
      "Mbt buitenland: reizen",
      "Callsheets doornemen, communicatie voorafgaand aan elke draaidag en -week",
      "Voorbereiding en onderhoud apparatuur"
    ],
    "afronding": [
      "Persoonlijke back-up maken van al het opgenomen set-geluid (tbv eigen back-up; masterschijven worden op set gemaakt)",
      "Bellen met beeldedit aan begin van de periode ivm overdracht richting beeldedit, soundfiles komen via masterschijven",
      "Langs bij beeldedit voor picture lock, eventuele moeilijkheden ondervangen richting sound-post",
      "Langs bij sound-post na overdracht picture lock, bekijken en beluisteren van het project, nabespreken van draaiperiode en bevindingen",
      "Langs bij sound-post in de mixweek, meeluisteren bij mix-week, bijsturen waar kan"
    ],
    "pr_promotie": []
  },
  "montage": {
    "label": "Montage",
    "hoofdwerk": [
      "Assembly montage, eerste versie",
      "Montage",
      "Viewings en vervolgsessies",
      "Aansturen VFX, componist, titels etc.",
      "Picture lock",
      "Montage trailer, crewfilmpjes en ander promotiemateriaal",
      "Postproductie vergadering"
    ],
    "voorbereiding": [
      "Script lezen en adviezen",
      "Technisch voorbereiden materiaal (converteren, syncen, loggen)",
      "Inhoudelijk voorbereiden voor montage"
    ],
    "afronding": [
      "Administratie tbv geluidsnabewerking, beeld post, muziek, VFX, etc.",
      "Exporteren tbv geluidsnabewerking, beeld post, muziek, VFX etc.",
      "Overdracht inhoudelijk en technisch aan geluidsnabewerking, beeld post, muziek, VFX, etc.",
      "Begeleiding van geluidsnabewerking, beeld post, muziek, VFX, etc.",
      "Aanwezig bij mixage",
      "Check conform, titels, DCP, etc."
    ],
    "pr_promotie": []
  },
  "muziek": {
    "label": "Muziek",
    "hoofdwerk": [
      "Componeren, arrangeren, productie",
      "Overleg, feedback verwerken, correcties",
      "Muziek mixage",
      "Opnames"
    ],
    "voorbereiding": [
      "Muzikaal schetsen maken",
      "Meetings en overleggen"
    ],
    "afronding": [
      "Orkestreren",
      "Eindsessies voorbereiden en maken",
      "Opnames en mixen",
      "Soundtrack maken",
      "Script lezen",
      "Research",
      "Correcties achteraf",
      "Exports maken tbv transport muziek naar eindmix",
      "Bijwonen eindmix",
      "Administraties zoals cue sheets en Buma/Stemra aanmeldingen"
    ],
    "pr_promotie": []
  },
  "beeld-postproductie": {
    "label": "Beeld postproductie",
    "hoofdwerk": [
      "Nabewerking beeld",
      "Bouwen conform",
      "(Technische) controles",
      "Aansturen editor, teamleden",
      "Overleg"
    ],
    "voorbereiding": [
      "Verzamelen en importeren van beeldmateriaal",
      "Voorbereiding materiaal",
      "Voorbereiding van apparatuur",
      "Vooroverleggen"
    ],
    "afronding": [
      "Bijwonen viewings",
      "Exporteren en archiveren"
    ],
    "pr_promotie": []
  },
  "geluid-postproductie": {
    "label": "Geluid postproductie",
    "hoofdwerk": [
      "Conform, assembly",
      "Re-conform",
      "Geluidsontwerp",
      "Regie doorloop",
      "Edit",
      "Foley spot",
      "ADR Cue list",
      "Muziek spotten",
      "Tempmixes, tempviewing",
      "Pre-mix",
      "Eindmix",
      "Tussentijdse viewings"
    ],
    "voorbereiding": [
      "Script lezen en analyseren",
      "Stijlbespreking + voorbereiding",
      "Muziekmeeting + voorbereiding",
      "Ontwerpen PT sessie",
      "Budget maken + budgetbesprekingen",
      "Workflowtest",
      "Postmeeting + voorbereiding",
      "Dailies spotten",
      "Editversies kijken, feedback leveren",
      "Schetsen ontwerpen + aanleveren",
      "ADR voorbereiding"
    ],
    "afronding": [
      "Deliverables",
      "Quality Checks",
      "DCP check",
      "Redelivery",
      "Testdraaien vertoning, première",
      "Music Cue Sheet",
      "Trailer, teaser sound design + mix",
      "M&E maken",
      "M&E checks + deliverables",
      "Backups en archivering"
    ],
    "pr_promotie": []
  },
  "regie": {
    "label": "Regie",
    "hoofdwerk": [
      "Cast en crew voorbereiden en aansturen tijdens de opnames",
      "(Samen met de scenarist) belangrijkste scenariowijzigingen doorvoeren",
      "Mise-en-scène en cameravoering (decoupage) maken en afstemmen met acteurs en camerapersoon",
      "Creatief leiding geven aan de verschillende Heads Of Department (camera, production design, kostuum, geluid, SFX, VFX, etc.)",
      "Definitieve beslissingen nemen over o.a. cast, figuratie, locaties, decorontwerp, licht, geluid, keuze en gebruik technische apparatuur, kostuums, make-up",
      "(doorlopend) Afstemming met producent/uitvoerend producent over budget",
      "Draaischema maken en (dagelijks) aanpassen samen met producent/uitvoerend producent en 1st assistant",
      "Diversen: meedenken over persbezoeken, stillsfotografie, etc."
    ],
    "voorbereiding": [
      "Concept en vroege ontwikkeling: ontwikkelen filmidee, zoeken scenarist en producent, project pitchen bij financiers, uitwerken tot een volwaardig en verfilmbaar scenario, research",
      "Ontwikkeling en financiering: versies van het script schrijven, visie en filmstijl uitwerken, meedenken over productiebudget en draaischema, concepten ontwikkelen met HoD's, opdracht geven tot technische tests",
      "Pre-productie: acteurs casten, audities leiden, lezingen en repetities leiden, stijlbesprekingen leiden, storyboard/decoupage/shotlist maken, gesprekken met componist, locaties bezoeken en selecteren, kostuumdoorpassen overzien, finaliseren shooting script"
    ],
    "afronding": [
      "Meewerken aan post-productieplanning",
      "Supervisie beeld-edit",
      "Supervisie VFX",
      "Supervisie geluidsmontage",
      "Supervisie additionele geluidsopnamen met acteurs",
      "Supervisie muziekcompositie en/of gebruik bestaande muziek",
      "Supervisie grading",
      "Deelnemen aan test-screenings",
      "Definitieve master-copy checken en goedkeuren"
    ],
    "pr_promotie": [
      "Promotionele interviews, en beschikbaar zijn voor zulke interviews",
      "Aanwezigheid bij, en beschikbaarheid voor premières",
      "Contact houden met producent over verschillende mogelijkheden van distributie of verkoop"
    ]
  },
  "scenario": {
    "label": "Scenario",
    "hoofdwerk": [
      "Pitch-document schrijven (alle versies)",
      "Pitch-sessies in opdracht (bij Filmfonds, afnemers, Europese coproductieworkshops, etc.)",
      "Schrijven van logline (alle versies)",
      "Schrijven van Synopsis (alle versies)",
      "Schrijven van Beatsheet/Step-outline (alle versies)",
      "Schrijven van Treatment (alle versies)",
      "Schrijven van Bijbel/Karakterbijbel (alle versies)",
      "Schrijven van Pilot (alle versies)",
      "Schrijven van Lange lijnen/miniserie (alle versies)",
      "Schrijven van Dialoogversie/Scenario/script (alle versies)",
      "Schrijven van Formats (alle versies)",
      "Schrijven van Filmplan (documentaire, alle versies)",
      "Schrijven Schrijversvisie",
      "Feedbacksessies/notes (schriftelijk of in persoon)",
      "Lezing(en) (georganiseerde scriptlezing)",
      "Polish",
      "Rewrites",
      "Begeleiding/scriptcoaching",
      "Lezen script/schrijven scriptreport",
      "Eindredactie",
      "Leidinggeven/aansturen writersroom"
    ],
    "voorbereiding": [
      "Meetings (met opdrachtgever(s), afnemer(s), team samenstellen, kennismaken regisseur, oorspronkelijke auteur bij bewerking, etc.)",
      "Research (gesprekken voeren, bekijken van bestaande filmwerken, beluisteren van podcasts, leeswerk, bezoeken van locaties, historisch onderzoek, etc.)",
      "Brainstormsessies"
    ],
    "afronding": [
      "Herschrijven van scènes tijdens Opnames",
      "Schrijven van aanvullende dialogen/scènes in/ten gevolge van Montage",
      "Schrijven van Blauwtjes",
      "Schrijven van indieningsdocument(en)",
      "Schrijven/controleren van vertalingen"
    ],
    "pr_promotie": [
      "Geven van interviews",
      "Schrijven van promotionele teksten (of extra samenvattingen)",
      "Scholing/workshops/conferenties (indien aan de opdracht toe te schrijven of daarvoor vereist)"
    ]
  },
  "uitvoerende-productie": {
    "label": "Productie",
    "hoofdwerk": [
      "Uitvoerend producent: budgetbeheer, onderhandelingen HoD's, overzien van gehele productieproces, langetermijnstrategie",
      "Productieleiding: eerste contact voor crew, cast en equipment, incl. financiële onderhandelingen, day-to-day strategie",
      "Assistent Productieleiding: assisteert Productieleiding, onderhandelt dagcrew, dagcast en/of minibudgetten in het complete proces",
      "Productiecoördinator en/of secretaresse: korte termijn, day-to-day, administratief, ondersteunend, communicatie systematisch verspreiden",
      "Post-productie supervisor: post-budgetbeheer, post-productieplanning & onderhandelingen en deal maken met post-crew HoD's, overzien van gehele post-productieproces",
      "Post-productiecoördinator: korte termijn, day-to-day, administratief, planning, ondersteunend, communicatie systematisch verspreiden gedurende post-productieproces"
    ],
    "voorbereiding": [
      "Aansturing andere betrokkenen",
      "Financiële en administratieve werkzaamheden",
      "Praktische werkzaamheden (zoals schema's maken, hotels boeken)",
      "Overleg"
    ],
    "afronding": [
      "Uitvoerend producent: budget tot aan post afronden, facturen controleren, budget updaten",
      "Productieleiding: facturen controleren die PL zelf heeft onderhandeld of kennis van heeft, schades verwerken, boetes verwerken, retour equipment aansturen",
      "Assistent Productieleiding: opschonen van Dropbox en documentatie, definitief maken van administratieve documentatie, goedkeuren van facturen binnen takenbereik",
      "Productiecoördinator en/of secretaresse: opruimen, opschonen, administratie afronden, declaraties afronden, lopende zaken afronden",
      "Post-productie supervisor: budget overnemen van uitvoerend producent, alle werkzaamheden voor contractuele en juridische oplevering van definitieve film aan producent, distributeur, sales"
    ],
    "pr_promotie": []
  },
  "vfx-vp": {
    "label": "VFX / VP",
    "hoofdwerk": [
      "Uitwerking VFX elementen",
      "Supervisie alle VFX elementen",
      "Testen",
      "Aansturen editor, teamleden",
      "Overleg"
    ],
    "voorbereiding": [
      "Lezen en analyseren script",
      "Voorbereiding materiaal",
      "Voorbereiding van apparatuur",
      "Vooroverleggen"
    ],
    "afronding": [
      "Bijwonen viewings",
      "Exporteren en archiveren"
    ],
    "pr_promotie": []
  }
};
